// extracted by mini-css-extract-plugin
module.exports = {"Dashboard":"Dashboard_Dashboard__RMW7E","DashboardLeft":"Dashboard_DashboardLeft__3qFMT"};